<template>
  <div class="app-container">
    <div class="title">
      <div class="title--font">{{ topTitle }}</div>
      <div class="title--button">
        <el-button type="primary" size="small" @click="openAdd({}, 0)">
          新增
        </el-button>
        <myExportExcel
          :excelTitleList="titleList"
          :idsList="exportIdsList"
          :url="OUTSOURCING_EXPORT_URL.PROCESS_COOP_DELIVERY"
          :filter="searchData"
          :excelName="'工序委外发货'"
        />
        <printViewBtn
          :changeList="changeList"
          :modules="OUTSOURCING_PRINT_MODULES.PROCESS_COOP_DELIVERY"
          :printFun="processCoopDelivery_view"
          :allowLabelPrint="true"
        />
      </div>
    </div>
    <hr />
    <my-operate
      :id="'myOperate'"
      :titleList="titleList"
      :operationTitleData="[]"
      :titleOperationTitleData="titleOperationTitleData"
      :titleData="searchData"
      @titleOperationBtnClick="titleOperationBtnClick"
      @operationBtnClick="titleOperationBtnClick"
      @onStart="onStart"
      @onEnd="onEnd"
      @isShowClick="isShowClick"
      @widthClick="widthClick"
      @resetClick="resetClick"
      ref="myOperate"
    />
    <myHtml
      v-loading="listLoading"
      :height="this.$root.tableHeight - 50"
      :id="'bill_one'"
      :columnType="columnType"
      :list="list"
      :titleList="titleList"
      :tableBtnList="tableBtnList"
      :checkKey="'processCoopDeliveryId'"
      :keyData="['processCoopDeliveryId']"
      @btnClick="btnClick"
      @cellClickEvent="cellClickEvent"
      @resizableChange="resizableChange"
      @selectChangeEvent="selectChangeEvent"
      @selectAllCheckboxChange="selectAllCheckboxChange"
      ref="myTable"
    />
    <pagination
      :total="listQuery.total"
      :page.sync="listQuery.pageNum"
      :limit.sync="listQuery.pageSize"
      :page-sizes="[10, 20, 50, 100, 300]"
      style="text-align: right; float: right"
      @pagination="getList"
    />
    <div style="clear: both"></div>
    <myOrderAdd
      v-if="htmlDataDialogState.show1"
      :visible="htmlDataDialogState.show1"
      :homeIndex="homeIndex"
      :routeType="routeType"
      :routeQuery="routeQuery"
      @htmlDataDialogClose="htmlDataDialogClose"
    />
    <myOrderDetails
      v-if="htmlDataDialogState.show2"
      :visible="htmlDataDialogState.show2"
      :homeIndex="homeIndex"
      :routeQuery="routeQuery"
      @htmlDataDialogClose="htmlDataDialogClose"
    />
  </div>
</template>

<script>
import { processCoopDelivery_list, processCoopDelivery_view } from "@/api/myController/outsourcing";
import { OUTSOURCING_PRINT_MODULES } from "@/utils/outsourcingPrint";
import {
  OUTSOURCING_EXPORT_URL,
  buildExportIdsList,
} from "@/utils/outsourcingExport";
import { formatSpecLabel } from "@/utils/outsourcingProcessFinishDelivery";

export default {
  name: "outsourcingProcesses_finish",
  data() {
    return {
      htmlDataDialogState: { show1: false, show2: false },
      routeType: 0,
      routeQuery: {},
      homeIndex: 172,
      OUTSOURCING_PRINT_MODULES,
      OUTSOURCING_EXPORT_URL,
      processCoopDelivery_view,
      topTitle: "工序委外发货",
      listQuery: { total: 0, pageNum: 1, pageSize: 20 },
      searchData: { searchString: "" },
      titleOperationTitleData: [
        { name: "综合查询", value: "searchString", type: "text" },
        { name: "搜索", type: "button" },
        { name: "重置", type: "button" },
      ],
      listLoading: false,
      changeList: [],
      columnType: "columnAll",
      tableBtnList: ["详情"],
      list: [],
      titleList: [
        {
          id: 1,
          name: "工序委外订单号",
          value: "baseProcessOutsourcingDocNumber",
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 140,
        },
        {
          id: 2,
          name: "发货单号",
          value: "processCoopDeliveryNumber",
          isShow: true,
          dataType: "text",
          canEdit: false,
          color: "#1476c3",
          width: 150,
        },
        {
          id: 3,
          name: "产品编号",
          value: "baseMaterialNumber",
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 120,
        },
        {
          id: 4,
          name: "产品名称",
          value: "baseMaterialName",
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 140,
        },
        {
          id: 5,
          name: "规格",
          value: "specifications",
          isShow: true,
          dataType: "textList",
          canEdit: false,
          width: 160,
        },
        {
          id: 6,
          name: "本次出货数量",
          value: "baseOutsourcingFinishedQuantity",
          isShow: true,
          dataType: "number",
          canEdit: false,
          width: 110,
        },
        {
          id: 7,
          name: "审核状态",
          value: "statusCheck",
          isShow: true,
          dataType: "customSelect",
          selectOptionList: [
            {
              label: "已审核",
              value: 1,
              color: "white",
              backGroundColor: "rgb(103,194,58)",
            },
            {
              label: "未审核",
              value: 0,
              color: "black",
              backGroundColor: "rgb(220,223,230)",
            },
          ],
          canEdit: false,
          width: 90,
        },
        {
          id: 8,
          name: "出库状态",
          value: "statusOutwarehouse",
          isShow: true,
          dataType: "customSelect",
          selectOptionList: [
            {
              label: "已出库",
              value: 1,
              color: "white",
              backGroundColor: "rgb(103,194,58)",
            },
            {
              label: "未出库",
              value: 0,
              color: "black",
              backGroundColor: "rgb(220,223,230)",
            },
          ],
          canEdit: false,
          width: 90,
        },
        {
          id: 9,
          name: "创建时间",
          value: "createTime",
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 150,
        },
      ],
    };
  },
  computed: {
    exportIdsList() {
      return buildExportIdsList(this.changeList, "processCoopDeliveryId");
    },
  },
  created() {
    const query = this.$route.query || {};
    if (query.processOutsourcingDocNumber) {
      this.searchData.searchString = query.processOutsourcingDocNumber;
    }
    this.getList();
  },
  methods: {
    normalizeItem(item) {
      const row = { ...item };
      if (
        row.statusOutwarehouse === undefined &&
        row.status_outwarehouse !== undefined
      ) {
        row.statusOutwarehouse = row.status_outwarehouse;
      }
      try {
        row.specifications = JSON.parse(row.baseSpecgroupDesc || "[]");
      } catch (error) {
        row.specifications = [];
      }
      if (!row.specifications.length && row.baseSpecgroupDesc) {
        row.specifications = [{ specValue: formatSpecLabel(row) }];
      }
      return row;
    },
    getList() {
      this.listLoading = true;
      const filter = {};
      if (this.searchData.searchString) {
        filter.searchString = this.searchData.searchString;
      }
      processCoopDelivery_list({
        cooperativeProcessDeliveryDtoFilter: filter,
        pageParam: {
          pageNum: this.listQuery.pageNum,
          pageSize: this.listQuery.pageSize,
        },
      })
        .then((res) => {
          const pageData = res.data.data || {};
          this.list = (pageData.dataList || []).map((item) =>
            this.normalizeItem(item)
          );
          this.listQuery.total = pageData.totalCount || 0;
        })
        .catch(() => {
          this.list = [];
          this.listQuery.total = 0;
        })
        .finally(() => {
          this.listLoading = false;
          this.$refs.myOperate?.dragSortShow();
        });
    },
    openAdd(routeQuery = {}, routeType = 0) {
      this.routeQuery = routeQuery;
      this.routeType = routeType;
      this.homeIndex = 172;
      this.htmlDataDialogState.show1 = true;
    },
    titleOperationBtnClick(item) {
      if (item.name === "搜索") {
        this.listQuery.pageNum = 1;
        this.getList();
      } else if (item.name === "重置") {
        this.searchData = { searchString: "" };
        this.listQuery.pageNum = 1;
        this.getList();
      }
    },
    btnClick(row, item) {
      if (item === "详情") {
        this.routeQuery = row;
        this.homeIndex = 172;
        this.htmlDataDialogState.show2 = true;
      }
    },
    cellClickEvent(row, column) {
      if (column.field === "processCoopDeliveryNumber") {
        this.btnClick(row, "详情");
      }
    },
    selectChangeEvent(val) {
      this.changeList = val.records || [];
    },
    selectAllCheckboxChange(val) {
      this.changeList = val.records || [];
    },
    htmlDataDialogClose() {
      this.htmlDataDialogState.show1 = false;
      this.htmlDataDialogState.show2 = false;
      this.routeType = 0;
      this.routeQuery = {};
      this.getList();
    },
    resizableChange(val) {
      this.titleList.forEach((item) => {
        if (item.value === val.field && item.name === val.title) {
          item.width = val.renderWidth;
        }
      });
    },
    onStart() {},
    onEnd(titleList) {
      this.titleList = titleList;
    },
    isShowClick(titleList) {
      this.titleList = titleList;
    },
    widthClick(titleList) {
      this.titleList = titleList;
    },
    resetClick(titleList) {
      this.titleList = titleList;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
}
.title--font {
  padding: 10px 0;
}
.title--button {
  position: absolute;
  right: 0;
  margin-top: 0.7%;
}
</style>
